<template>
  <ul class="nav" :class="$props.class" role="navigation">

    <li class="nav-item" v-for="(item,idx) in items"
        :class="{'dropdown':item.link, ...{[itemClass as string]:itemClass}}">

      <!-- menu item -->
      <a class="nav-link"
         :class="{'active': idx === active}"
         :href="item.link ? item.link : '#'"
         :target="item.target"
         @click="pushPage(item.push)"
         v-if="item.link || item.push">{{ item.name }}</a>

      <!-- submenu button -->
      <a class="nav-link dropdown-toggle" data-bs-toggle="dropdown"
         role="button"
         aria-expanded="false"
         v-if="!(item.link || item.push)">{{ item.name }}</a>

      <!-- submenu -->
      <ul class="dropdown-menu" v-if="!(item.link || item.push)">
        <li v-for="subItem in item.subItems">
          <a class="dropdown-item"
             :href="subItem.link? subItem.link: '#'"
             :target="subItem.target">
            {{ subItem.name }}
          </a>
        </li>
      </ul>
    </li>

  </ul>
</template>

<script lang="ts">
import {defineComponent, PropType} from "vue"

interface NavItem {
  name: string
  link?: string
  push?: string
  target?: string
  subItems?: NavItem[]
}

export default defineComponent({
  name: 'BootstrapNav',
  props: {
    class: String,
    itemClass: String,
    items: Object as PropType<NavItem[]>,
    active: {type: Number, default: 0},
  },
  methods: {
    pushPage(page: string | undefined) {
      if (page) this.$router.push(page)
    }
  }
})
</script>
